module.exports = __webpack_public_path__ + "media/4.4dcc4f5a.mp3";